import list from './list';
import { default as icon } from '@mui/icons-material/Event';
import { Create, Edit } from 'react-admin';
import { FormFields } from './components';

const create = () => (
	<Create>{FormFields}</Create>
);

const edit = () => (
	<Edit>{FormFields}</Edit>
);

export const Session = {
	list,
	edit,
	create,
	icon
};

export default Session;